export default __webpack_public_path__ + "pgnv-assets/bac8d982af701e4e27a594ef4b19761b.png";